import GenericField from '@shared/fields/generic-field';

import { SubprogramPaymentModel } from  '@modules/subprogram/subprogram-payment-model';

export default class SubprogramPaymentField extends GenericField {
  constructor(name, label) {
    super();
    this.name = name;
    this.label = label;
    this.initialValue = Object.keys(SubprogramPaymentModel.fields).reduce((result, field) => {
      result[field] = undefined;
      return result;
    }, {});
  }

  forPresenter(value) {
    return value || this.initialValue;
  }

  forFilterInitialValue(value) {
    return value || this.initialValue;
  }

  forFormInitialValue(value) {
    return value || this.initialValue;
  }

  forFilterCast() { }

  forFilterRules() { }

  forFormCast() { }

  forFormRules() { }
}